import { render, staticRenderFns } from "./PlatformProjectDetails.vue?vue&type=template&id=f3d9c608&"
import script from "./PlatformProjectDetails.vue?vue&type=script&lang=js&"
export * from "./PlatformProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports